import { render, staticRenderFns } from "./ServicesPricingForm.vue?vue&type=template&id=130c9f4a&scoped=true&"
import script from "./ServicesPricingForm.vue?vue&type=script&lang=js&"
export * from "./ServicesPricingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c9f4a",
  null
  
)

export default component.exports